import React from "react";
import i18next from "../../i18n.js";
import { useNavigate } from 'react-router-dom';
import { BackgroundContainer } from "../account/BackgroundContaner.js";
import { Button } from "react-bootstrap";
import { urls, backgroundTypes } from "../../constants.js";

const ServiceNotAvailablePage = () => {
    const navigate = useNavigate();

    const onBtnClick = () => {
        navigate(urls.loginPage);
    }

    return (<BackgroundContainer type={backgroundTypes.account}>
        <div className="form-page">
            <div className="form-block large-form">
                <div className="form-content">
                    <div className="form-group">
                        <div className="info-message-title">{i18next.t("error")}</div>
                        <div className="info-message">{i18next.t("statusCode.500.Title")} {i18next.t("statusCode.500.SubTitle")}</div>
                    </div>
                    <div className="form-group form-group__last"><Button variant="primary" className="center" onClick={onBtnClick}>{i18next.t("ok")}</Button></div>
                </div>
            </div>
        </div>
    </BackgroundContainer>);
}

export default ServiceNotAvailablePage;